import { render } from "./PopUpDuplicateExerciseSheet.vue?vue&type=template&id=3c1b3516"
import script from "./PopUpDuplicateExerciseSheet.vue?vue&type=script&lang=js"
export * from "./PopUpDuplicateExerciseSheet.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__